
















































































import Vue from 'vue';
import UserResourceViewModel from '../../../services/viewModel/resource/UserResourceViewModel';
import ResendVerificationCodeRequestViewModel from '../../../services/viewModel/request/Me/ResendVerificationCodeRequestViewModel';

export default Vue.extend({
  auth: true,
  role: ['admin', 'hostadmin'],
  layout: 'layout-hostadmin',
  data: () => ({
    isLoading: false,
    userDetail: new UserResourceViewModel(),
    sendVerification: new ResendVerificationCodeRequestViewModel(),
    verificationSentOn: undefined as string | undefined,
    verificationExpires: undefined as string | undefined,
    modifierName: undefined as string | undefined,
    errorMessage: undefined as string | undefined,
    successMessage: undefined as string | undefined,
  }),
  computed: {
    canEdit(): boolean {
      if (!this.$auth.isInRole('HostAdmin') && this.userDetail.appHostRoleId === 1) {
        // Only a HostAdmin can edit a HostAdmin
        return false;
      }
      return true;
    },
    canSave(): boolean {
      return this.userDetail.userName !== undefined
        && this.userDetail.email !== undefined
        && this.userDetail.statusId !== undefined
        && this.userDetail.appHostRoleId !== undefined
        && !this.isLoading
        && this.canEdit;
    },
    roles(): {caption: string, id?: number, detail?: string}[] {
      // TODO: Get this from backend! At the very least the ids should not be hardcoded!
      let hostAdminEntry = [] as any[];
      if (this.$auth.isInRole('HostAdmin')) {
        hostAdminEntry = [{
          caption: this.$t('core.page.user.appHostRoleId.1'),
          id: 1,
        }];
      }
      return [
        ...hostAdminEntry,
        {
          caption: this.$t('core.page.user.appHostRoleId.2'),
          id: 2,
        },
        {
          caption: this.$t('core.page.user.appHostRoleId.3'),
          id: 3,
        },
        {
          caption: this.$t('core.page.user.appHostRoleId.4'),
          id: 4,
        },
      ];
    },
    verified(): {caption: string, id?: number}[] {
      // TODO: Get this from backend! At the very least the ids should not be hardcoded!
      return [
        {
          caption: this.$t('core.page.user.select.unverified'),
          id: 0,
        },
        {
          caption: this.$t('core.page.user.select.verified'),
          id: 1,
        },
        {
          caption: this.$t('core.page.user.select.blocked'),
          id: 2,
        },
        {
          caption: this.$t('core.page.user.select.disabled'),
          id: 3,
        },
      ];
    },
    userId(): number {
      const { id } = Vue.$router.currentRoute.params;
      return Number.parseInt(id, 10);
    },
  },
  async mounted() {
    await this.getUserInformation();
  },
  methods: {
    async getUserInformation() {
      this.isLoading = true;
      try {
        await this.$auth.refresh();
        const response = await this.$service.api.core.users.getUserById(this.userId);
        this.userDetail = response;
        if (!this.userDetail.modifierId) {
          this.modifierName = 'None';
        } else {
          const modifier = await this.$service.api.core.users.getUserById(this.userDetail.modifierId);
          this.modifierName = modifier.userName!;
        }
        this.sendVerification.email = response.email!;
        this.verificationExpires = this.$format.localDateAndTime(this.userDetail.verificationCodeValidUntil as string);
        this.verificationSentOn = this.$format.localDateAndTime(this.userDetail.verificationCodeSentOn as string);
      } catch (error: any) {
        this.errorMessage = error;
      }
      this.isLoading = false;
    },
    async sendCode() {
      if (!this.canEdit) {
        return;
      }
      this.isLoading = true;
      try {
        await this.$service.api.core.me.resendVerificationCode(this.sendVerification);
        this.verificationSentOn = this.$format.localDateAndTime(this.$date.now().format());
        this.successMessage = this.$t('core.page.user.message.verficationCodeWasSendSuccessfuly');
        await this.getUserInformation();
      } catch (error: any) {
        this.errorMessage = error;
      }
      this.isLoading = false;
    },
    async saveUser() {
      if (!this.canEdit) {
        return;
      }
      if (!this.userDetail.id) {
        this.errorMessage = this.$t('core.page.user.message.noUserIdAvaible');
        return;
      }

      this.isLoading = true;
      try {
        const allPromises = [];
        allPromises.push(this.$service.api.core.users.updateUser(this.userDetail.id, this.userDetail));
        allPromises.push(this.$service.api.core.users.setUserStatus(this.userDetail.id, this.userDetail.statusId!));
        allPromises.push(this.$service.api.core.users.setUserAppRole(this.userDetail.id, this.userDetail.appHostRoleId!));

        await Promise.all(allPromises);
        await this.getUserInformation();
        this.successMessage = this.$t('core.page.user.message.userWasSuccessfulyUpdated');
      } catch (error: any) {
        this.errorMessage = error;
      }
      this.isLoading = false;
    },
    back() {
      this.$router.back();
    },
  },
});
